<template>
    <el-dialog class="dialog" :visible="dialogs.generalWorkFunction" customClass="dialog_main" :append-to-body="true" :close-on-click-modal="false" @close="closeDialog()">
        <div slot="title" class="dialog__head dialog__head_second">
            <div class="dialog__head-inner">
                <h3 class="dialog__title">Общие трудовые функции</h3>
            </div>
        </div>

        <div class="dialog__inner">
            <div class="dialog__content">
                <form class="search-form" @submit.prevent="search">
                    <div class="search-form__inner">
                        <input type="search" class="input search-form__input" :class="{ 'search-form__input_reset': input && input.length !== 0 }" placeholder="Поиск" v-model.trim="input">

                        <button v-if="input && input.length !== 0" class="search-form__reset" @click="input = ''">
                            <icon-base viewBox="0 0 14 14"><icon-cancel /></icon-base>
                        </button>

                        <button type="submit" class="search-form__submit">
                            <icon-base viewBox="0 0 24 24"><icon-search /></icon-base>
                        </button>
                    </div>
                </form>

                <h3 v-if="start" class="dialog__title mt-32 mb-32">Введите в поисковую строку или создайте новое ОТФ, чтобы выбрать ОТФ для добавления</h3>

                <div v-show="!start">
                    <el-table
                        cell-class-name="table__cell"
                        class="table table_second"
                        header-cell-class-name="table__title"
                        max-height="300"
                        ref="table"
                        row-key="id"
                        :data="filteredData"
                        :default-sort="{ prop: 'code', order: 'ascending' }"
                        @sort-change="sortChange"
                    >
                        <el-table-column
                                width="24"
                        >
                            <template slot-scope="scope">
                                <div class="table_flex">
                                    <el-checkbox @change="handleSelectionChange([scope.row])"/>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="Код"
                            prop="code"
                            sortable
                            :min-width="10"
                            :sort-orders="['ascending', 'descending']"
                        >
                        </el-table-column>
                        <el-table-column
                            label="Название"
                            prop="name"
                            sortable
                            :min-width="90"
                            :sort-orders="['ascending', 'descending']"
                        >
                        </el-table-column>
                    </el-table>

                    <h3 class="dialog__title mt-32 mb-16">Выбранные сущности</h3>

                    <el-table
                        cell-class-name="table__cell"
                        class="table table_second"
                        header-cell-class-name="table__title"
                        max-height="300"
                        row-key="id"
                        :show-header="false"
                        :data="selection"
                        :default-sort="{ prop: 'code', order: 'ascending' }"
                    >
                        <el-table-column
                            width="24"
                        >
                            <template slot-scope="scope">
                                <div class="table_flex">
                                    <el-checkbox checked @change="deleteSelectionChange([scope.row])"/>
                                </div>
                            </template>
                        </el-table-column>
                    <el-table-column
                            label="Код"
                            prop="code"
                            sortable
                            :min-width="10"
                            :sort-orders="['ascending', 'descending']"
                        >
                        </el-table-column>
                        <el-table-column
                            label="Название"
                            prop="name"
                            sortable
                            :min-width="90"
                            :sort-orders="['ascending', 'descending']"
                        >
                        </el-table-column>
                    </el-table>
                </div>
            </div>

            <footer slot="footer" class="dialog__footer mt-24">
                <div class="dialog__footer-inner">
                    <div class="dialog__footer-item">
                        <button type="button" class="btn" @click="closeDialog">Отменить</button>
                    </div>
                    <div class="dialog__footer-item">
                        <button type="submit" class="btn btn_action" :disabled="selection.length === 0" @click="submitSelected">Добавить выбранные ОТФ</button>
                    </div>
                </div>
            </footer>
        </div>
    </el-dialog>
</template>

<script>
import { mapActions, mapState } from 'vuex';

import constants from '@/constants.js';
import dialog from '@/mixins/dialog';

export default {
    mixins: [ dialog ],
    data() {
        return {
            start: true
        }
    },
    methods: {
        ...mapActions('editor', [
            'LOAD_COMMON_WORK_FUNCTIONS',
            'LOAD_COMMON_WORK_FUNCTION',
            'LOAD_WORK_FUNCTIONS_BY_STANDARD',
            'UPDATE_WORK_FUNCTIONS_BY_STANDART',
        ]),
        closeDialog() {
            this.selection = []
            this.start = true

            this.elDialogs.generalWorkFunction = false;
        },

        handleSelectionChange(val) {
            this.selection = [...val, ...this.selection];
        },
        deleteSelectionChange(val) {
            this.selection = this.selection.filter(select => !val.find(item => item.id === select.id))
        },
        search() {
            this.LOAD_COMMON_WORK_FUNCTIONS(this.input).then(() => {
                this.data = [...this.commonWorkFunctions];
            });
            this.start = false
        },
        sortChange(v) {
            if (v.column.order === 'ascending') {
                this.data.sort(this.sortListAsc(v.column.property));
            } else if (v.column.order === 'descending') {
                this.data.sort(this.sortListDesc(v.column.property));
            }
        },
        async submitSelected() {
            const temp = this.selection.concat(this.workFunctionsByStandard)
            const ids = temp.map((item) => item.id)

            await this.UPDATE_WORK_FUNCTIONS_BY_STANDART({
                standardId: this.standard.id,
                ids
            })

            await this.LOAD_WORK_FUNCTIONS_BY_STANDARD(this.standard.id)

            this.closeDialog()
        }
    },
    computed: {
        ...mapState('editor', ['commonWorkFunctions', 'standard', 'workFunctionsByStandard']),

        filteredData() {
            return this.data.filter(el => !this.workFunctionsByStandard.find(workFunctionByStandard => workFunctionByStandard.id === el.id))
                .filter(el => !this.selection.find(select => select.id === el.id))
        }
    },
    created() {
        this.SELECT_NOT_FOUND = constants.SELECT_NOT_FOUND;
    }
}
</script>
